import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Top from '../components/Top/Top.vue'
import Cultivation from '@/components/CultivationPlan/CultivationPlan.vue';
import Workers from '@/components/Workers/Workers.vue'
import IncomeAndOutgo from '@/components/IncomeAndOutgo/IncomeAndOutgo.vue'
import IncomeAndOutgoGroup from '@/components/IncomeAndOutgo/IncomeAndOutgoAgriFieldGroup/IncomeAndOutgoAgriFieldGroup.vue'
import IncomeAndOutgoCrops from '@/components/IncomeAndOutgo/IncomeAndOutgoCrops/IncomeAndOutgoCrops.vue'
import IncomeAndOutgoDetail from '@/components/IncomeAndOutgo/IncomeAndOutgoAgriFieldDetail/IncomeAndOutgoAgriFieldDetail.vue'
import IncomeAndOutgoCropDetail from '@/components/IncomeAndOutgo/IncomeAndOutgoCropDetail/IncomeAndOutgoCropDetail.vue'
import IncomeDetail from '@/components/IncomeAndOutgo/IncomeAndOutgoAgriFieldIncomeDetail/IncomeAndOutgoAgriFieldIncomeDetail.vue'
import OutgoDetail from '@/components/IncomeAndOutgo/IncomeAndOutgoAgriFieldOutgoDetail/IncomeAndOutgoAgriFieldOutgoDetail.vue'
import IncomePlantingDetail from '@/components/IncomeAndOutgo/IncomeAndOutgoPlantingIncomeDetail/IncomeAndOutgoPlantingIncomeDetail.vue';
import OutgoPlantingDetail from '@/components/IncomeAndOutgo/IncomeAndOutgoPlantingOutgoDetail/IncomeAndOutgoPlantingOutgoDetail.vue';
import store from '@/assets/common/store/store';
import MasterSetting from '@/components/MasterSetting/MasterSetting.vue';
import Management from '@/components/Management/Management.vue';
import WorkItems from '@/components/WorkItems/WorkItems.vue';
import Machines from '@/components/Machines/Machines.vue';
import Warehouses from '@/components/Warehouses/Warehouses.vue';
import CalendarPage from '@/components/CalendarPage/CalendarPage.vue';
import Record from '@/components/Record/Record.vue'
import ShippingRecord from '@/components/Record/ShippingRecord/ShippingRecord.vue';
import WorkRecord from '@/components/Record/WorkRecord/WorkRecord.vue';
import DisposalRecord from '@/components/Record/DisposalRecord/DisposalRecord.vue';
import HarvestRecord from '@/components/Record/HarvestRecord/HarvestRecord.vue';
import HarvestShipping from '@/components/HarvestShipping/HarvestShipping.vue';
import DashboardMain from "@/components/Dashboard/DashboardMain.vue";
import Dashboard from '@/components/Dashboard/Dashboard/Dashboard.vue';
import DashboardSetting from '@/components/Dashboard/DashboardSetting/DashboardSetting.vue';
import Fertilizers from '@/components/Fertilizers/Fertilizers.vue';
import FertilizerModal from '@/components/FertilizerModal/FertilizerModal.vue';
import Seedlings from '@/components/Seedlings/Seedlings.vue';
import Materials from '@/components/Materials/Materials.vue'
import UserList from '@/components/UserList/UserList.vue';
import SalesResult from '@/components/SalesResult/SalesResult.vue';
import HarvestResult from '@/components/HarvestResultByMonth/HarvestResultByMonth.vue';
import WorkResult from '@/components/WorkResult/WorkResult.vue';
import Notification from '@/components/Notification/Notification.vue'
import NotificationStatusBySubscriberList from '@/components/Notification/NotificationstatusbySubscriber/NotificationstatusbySubscriberList/NotificationstatusbySubscriberList.vue';
import NotificationStatusByNotification from '@/components/Notification/NotificationStatusByNotification/NotificationStatusByNotification.vue';
import List from '@/components/List/List.vue';
import PlantingList from '@/components/List/PlantingList/PlantingList.vue'
import WorkRecordList from '@/components/List/WorkRecordList/WorkRecordList.vue'
import WorkerGoalList from '@/components/WorkerGoal/WorkerGoal.vue'
import HarvestList from '@/components/List/HarvestList/HarvestList.vue'
import ShippingList from '@/components/List/ShippingList/ShippingList.vue'
import ShippingCollectiveRegisterList from '@/components/AdditionalFunction/ShippingCollectiveRegisterList/ShippingCollectiveRegisterList.vue'
import AdditionalFunction from '@/components/AdditionalFunction/AdditionalFunction.vue'
import JasperReports from '@/components/JasperReports/JasperReports.vue';
import Committees from '@/components/Committees/Committees.vue';
import CultivationHistoryList from '@/components/CultivationHistoryList/CultivationHistoryList.vue';
import PesticideNavigator from '@/components/PesticideNavigator/PesticideNavigator';
import ShippingItems from '@/components/PesticideNavigator/ShippingItems/ShippingItems.vue';
import ProducerList from '@/components/ProducerList/ProducerList.vue';
import ItemHiraganaChange from '@/components/ItemHiraganaChange/ItemHiraganaChange.vue';
import ChemicalImportErrorList from '@/components/ChemicalImportErrorList/ChemicalImportErrorList.vue';


Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/calendar'
  },
  {
    path: '/dashboard',
    component: DashboardMain,
    meta: {
      pageName: 'ダッシュボード',
      parent: true
    },
    children: [
      {
        path: '/',
        component: Dashboard,
        meta: {
          pageName: 'ダッシュボード',
          parent: true
        }
      },
      {
        path: 'setting',
        component: DashboardSetting,
        meta: {
          pageName: 'ダッシュボード設定'
        }
      }
    ]
  },
  {
    path: '/master',
    component: MasterSetting,
    meta: {
      pageName: 'マスター設定',
      parent: true
    },
    children: [
      {
        path: '/',
        name: 'Top',
        component: Top,
        meta: {
          pageName: ''
        }
      },
      //このルータプッシュコードソースは、マスター画面がモーダルに変換されるためコメントされています。
      // {
      //   path: 'seedlings',
      //   name: 'Seedlings',
      //   component: Seedlings,
      //   meta: {
      //     pageName: '品種'
      //   }
      // },
      // {
      //   path: 'seedlings/:seedling_id',
      //   name: 'SeedlingsDetail',
      //   component: Seedlings,
      //   props: (route) => ({ id: route.params.seedling_id }),
      //   meta: {
      //     pageName: '品種'
      //   }
      // },
      {
        path: 'workers',
        name: 'Workers',
        component: Workers,
        meta: {
          pageName: '作業者'
        }
      },
      {
        path: 'workers/:worker_id',
        name: 'WorkersDetail',
        component: Workers,
        props: (route) => ({ id: route.params.worker_id }),
        meta: {
          pageName: '作業者'
        }
      },
      {
        path: '/cultivation',
        name: 'Cultivation',
        component: Cultivation,
        meta: {
          pageName: '栽培'
        }
      },
      //このルータプッシュコードソースは、マスター画面がモーダルに変換されるためコメントされています。
      // {
      //   path: 'work_items',
      //   name: 'WorkItems',
      //   component: WorkItems,
      //   meta: {
      //     pageName: '作業項目'
      //   }
      // },
      // {
      //   path: 'work_items/:work_items_id',
      //   name: 'WorkItemsDetail',
      //   component: WorkItems,
      //   props: (route) => ({ id: route.params.work_items_id }),
      //   meta: {
      //     pageName: '作業項目'
      //   }
      // },
      {
        path: 'machines',
        name: 'Machines',
        component: Machines,
        meta: {
          pageName: '機械'
        }
      },
      {
        path: 'machines/:machines_id',
        name: 'MachinesDetail',
        component: Machines,
        props: (route) => ({ id: route.params.machines_id }),
        meta: {
          pageName: '機械'
        }
      },
      {
        path: 'warehouses',
        name: 'Warehouses',
        component: Warehouses,
        meta: {
          pageName: '倉庫'
        }
      },
      {
        path: 'warehouses/:warehouses_id',
        name: 'WarehousesDetail',
        component: Warehouses,
        props: (route) => ({ id: route.params.warehouses_id }),
        meta: {
          pageName: '倉庫'
        }
      },
      //このルータプッシュコードソースは、マスター画面がモーダルに変換されるためコメントされています。
      // {
      //   path: 'fertilizers',
      //   name: 'Fertilizers',
      //   component: Fertilizers,
      //   meta: {
      //     pageName: '肥料'
      //   }
      // },
      // {
      //   path: 'fertilizers/:fertilizer_id',
      //   name: 'FertilizersDetail',
      //   component: Fertilizers,
      //   props: (route) => ({ id: route.params.fertilizer_id }),
      //   meta: {
      //     pageName: '肥料'
      //   }
      // },
      // {
      //   path: 'materials',
      //   name: 'Materials',
      //   component: Materials,
      //   meta: {
      //     pageName: '資材'
      //   }
      // },
      // {
      //   path: 'materials/:materilas_id',
      //   name: 'MaterialsDetail',
      //   component: Materials,
      //   props: (route) => ({ id: route.params.materials_id}),
      //   meta: {
      //     pageName: '資材'
      //   }
      // },
      // {
      //   path: 'harvest_shipping',
      //   name: 'HarvestShipping',
      //   component: HarvestShipping,
      //   meta: {
      //     pageName: '収穫・出荷'
      //   }
      // },
      // {
      //   path: 'harvest_shipping/:harvest_shipping_id',
      //   name: 'HarvestShippingDetail',
      //   component: HarvestShipping,
      //   props: (route) => ({ id: route.params.harvest_shipping_id }),
      //   meta: {
      //     pageName: '収穫・出荷'
      //   }
      // },
      {
        path: 'committees',
        name: 'Committees',
        component: Committees,
        meta: {
          pageName: '部会'
        }
      },
      {
        path: 'committees/:committee_id',
        name: 'CommitteeDetail',
        component: Committees,
        props: (route) => ({ id: route.params.committee_id }),
        meta: {
          pageName: '部会'
        }
      },
    ]
  },
  
  {
    path: '/aggregation',
    name: 'Aggregation',
    component: Management,
    meta: {
      pageName: '集計',
      parent: true
    },
    children: [
      {
        path: 'income-and-outgo',
        name: 'IncomeAndOutgo',
        component: IncomeAndOutgo,
        meta: {
          pageName: '収支'
        },
        children: [
          {
            path: 'agri-field-groups',
            name: 'AgriFieldGroupsIncomeAndOutgo',
            component: IncomeAndOutgoGroup,
            meta: {
              parents: ['収支'],
              pageName: '圃場'
            }
          },
          {
            path: 'agri-field-groups/:agri_field_group_id',
            name: 'AgriFieldGroupIncomeAndOutgo',
            component: IncomeAndOutgoDetail,
            props: (route) => ({ agriFieldGroupId: route.params.agri_field_group_id }),
            meta: {
              parents: ['収支'],
              pageName: '圃場'
            }
          },
          {
            path: 'agri-field-groups/:agri_field_group_id/income/:agri_field_id',
            name: 'AgriFieldIncomeDetail',
            component: IncomeDetail,
            props: (route) => ({
              agriFieldGroupId: route.params.agri_field_group_id,
              agriFieldId: route.params.agri_field_id
            }),
            meta: {
              parents: ['収支'],
              pageName: '圃場'
            }
          },
          {
            path: 'agri-field-groups/:agri_field_group_id/outgo/:agri_field_id',
            name: 'AgriFieldOutgoDetail',
            component: OutgoDetail,
            props: (route) => ({
              agriFieldGroupId: route.params.agri_field_group_id,
              agriFieldId: route.params.agri_field_id
            }),
            meta: {
              parents: ['収支'],
              pageName: '圃場'
            }
          },
          {
            path: 'crops',
            name: 'CropsIncomeAndOutgo',
            component: IncomeAndOutgoCrops,
            meta: {
              parents: ['収支'],
              pageName: '作目'
            }
          },
          {
            path: 'crops/:crop_id',
            name: 'CropIncomeAndOutgo',
            component: IncomeAndOutgoCropDetail,
            props: (route) => ({ cropId: route.params.crop_id }),
            meta: {
              parents: ['収支'],
              pageName: '作目'
            }
          },
          {
            path: 'crops/:crop_id/income/:planting_id',
            name: 'PlantingIncomeDetail',
            component: IncomePlantingDetail,
            props: (route) => ({
              cropId: route.params.crop_id,
              plantingId: route.params.planting_id
            }),
            meta: {
              parents: ['収支'],
              pageName: '作目'
            }
          },
          {
            path: 'crops/:crop_id/outgo/:planting_id',
            name: 'PlantingOutgoDetail',
            component: OutgoPlantingDetail,
            props: (route) => ({
              cropId: route.params.crop_id,
              plantingId: route.params.planting_id
            }),
            meta: {
              parents: ['収支'],
              pageName: '作目'
            }
          }
        ]
      },
      {
        path: 'report',
        name: 'Report',
        meta: {
          pageName: 'レポート'
        }
      },
      {
        path: 'sales-results/monthly',
        name: 'SalesResultByMonthly',
        component: SalesResult,
        meta: {
          pageName: '売上実績（月別）'
        }
      },
      {
        path: 'sales-results/shipping-destination',
        name: 'SalesResultByShippingDestination',
        component: SalesResult,
        meta: {
          pageName: '売上実績（出荷先別）'
        }
      },
      {
        path: 'sales-results/crop',
        name: 'SalesResultByCrop',
        component: SalesResult,
        meta: {
          pageName: '売上実績（作目別）'
        }
      },
      {
        path: 'sales-results/list',
        name: 'SalesResultByList',
        component: SalesResult,
        meta: {
          pageName: '売上実績一覧'
        }
      },
      {
        path: 'yield-by-crops/month',
        name: 'HarvestResultMonthly',
        component: HarvestResult,
        meta: {
          pageName: '収穫実績（月別）'
        }
      },
      {
      path: 'work-performance/employee',
        name: 'WorkResultByEmployee',
        component: WorkResult,
        meta: {
          pageName: '作業実績（従業員別）'
        }
      },
      {
      path: 'work-performance/field',
        name: 'WorkResultByField',
        component: WorkResult,
        meta: {
          pageName: '作業実績（圃場別）'
        }
      },
      {
        path: 'work-performance/crops',
          name: 'WorkResultByCrop',
          component: WorkResult,
          meta: {
            pageName: '作業実績（作付別）'
          }
      },
      {
        path: 'worker-goal-list',
        component: WorkerGoalList,
        name: 'workerGoalList',
        meta: {
          pageName: '作業目標一覧',
        }
      },
    ]
  },
  {
    path: '/management',
    name: 'Management',
    component: Management,
    meta: {
      pageName: '管理',
      parent: true
    },
    children: [
      {
        path: 'worker-goal-list',
        component: WorkerGoalList,
        name: 'workerGoalList',
        meta: {
          pageName: '作業目標一覧',
        }
      }
    ]
  },
  
  {
    path: '/calendar',
    name: 'Calendar',
    component: CalendarPage,
    meta: {
      pageName: 'カレンダー',
      parent: true
    }
  },
  {
    path: '/dashboard/setting',
    name: 'DashboardSetting',
    component: DashboardSetting,
    meta: {
      pageName: 'ダッシュボード設定'
    }
  },
  {
    path: '/notification-register',
    component: Notification,
    meta: {
      pageName: 'お知らせ登録',
      parent: true
    },
    children: [
      {
        path: '/notification-register/:notification_id',
        name: 'notification-register',
        component: Notification,
        props: (route) => ({ id: route.params.notification_id}),
      },
    ]
  },
  {
    path: '/notification-subscriber',
    component: NotificationStatusBySubscriberList,
    name: 'NotificationStatusBySubscriberList',
    meta: {
      pageName: 'お知らせ状況照会（契約者別）',
      parent:true
    }
  },
  {
    path: '/notification-status-by-notification',
    component: NotificationStatusByNotification,
    meta: {
      pageName: 'お知らせ状況照会（お知らせ別）',
      parent: true
    },
    children: [
      {
        path: '/notification-status-by-notification/:notification_id',
        name: 'notification-status-by-notification',
        component: NotificationStatusByNotification,
        props: (route) => ({ id: route.params.notification_id}),
      },
    ]
  },
  {
    path: '/record',
    name: 'Record',
    component: Record,
    meta: {
      pageName: '記録作成',
      parent: true
    },
    children: [
      {
        path: 'work',
        name: 'Work',
        component: WorkRecord,
        meta: {
          pageName: '作業記録'
        },
      },
      {
        path: 'work/:work_record_id',
        name: 'UpdateWork',
        component: WorkRecord,
        props: (route) => ({ id: route.params.work_record_id }),
        meta: {
          pageName: '作業記録'
        }
      },
      {
        path: 'harvest',
        name: 'Harvest',
        component: HarvestRecord,
        meta: {
          pageName: '収穫記録'
        },
      },
      {
        path: 'harvest/:harvest_record_id',
        name: 'UpdateHarvestRecord',
        component: HarvestRecord,
        props: (route) => ({ harvestRecordId: route.params.harvest_record_id }),
        meta: {
          pageName: '収穫記録'
        },
      },
      {
        path: 'shipping',
        name: 'Shipping',
        component: ShippingRecord,
        meta: {
          pageName: '出荷記録'
        },
      },
      {
        path: 'shipping/:shipping_record_id',
        name: 'UpdateShipping',
        component: ShippingRecord,
        props: (route) => ({ id: route.params.shipping_record_id }),
        meta: {
          pageName: '出荷記録'
        }
      },
      {
        path: 'disposal',
        name: 'disposal',
        component: DisposalRecord,
        meta: {
          pageName: '廃棄記録'
        },
      },
    ]
  },
  {
    path: '/list',
    name: 'List',
    component: List,
    meta: {
      pageName: '記録作成',
      parent: true
    },
    children: [
      {
        path: 'plantings',
        name: 'Plantings',
        component: PlantingList,
        meta: {
          pageName: '作付一覧'
        },
      },
      {
        path: 'work',
        name: 'work',
        component: WorkRecordList,
        meta: {
          pageName: '作業一覧'
        },
      },
      {
        path: 'harvest',
        name: 'harvest',
        component: HarvestList,
        meta: {
          pageName: '収穫一覧'
        },
      },
      {
        path: 'shipping',
        name: 'shipping',
        component: ShippingList,
        meta: {
          pageName: '出荷一覧'
        },
      },
    ]
  },
  {
    path: '/pesticide-navigator',
    name: 'PesticideNavigator',
    component: PesticideNavigator,
    meta: {
      pageName: 'ベジパレットコネクト',
      parent: true
    },
    children: [
      {
        path: 'shipping-items',
        name: 'ShippingItems',
        component: ShippingItems,
        meta: {
          pageName: '出荷品目'
        },
      },
      {
        path: 'shipping-items/:id',
        name: 'ShippingItemDetail',
        component: ShippingItems,
        props: (route) => ({ id: route.params.id }),
        meta: {
          pageName: '出荷品目'
        }
      },
      {
        path: 'cultivation-history-list',
        name: 'CultivationHistoryList',
        component: CultivationHistoryList,
        meta: {
          pageName: '栽培履歴一覧'
        },
      },
      {
        path: 'producer-list',
        name: 'ProducerList',
        component: ProducerList,
        meta: {
          pageName: '生産者一覧'
        },
      },
      {
        path: 'item-hiragana-change',
        name: 'ItemHiraganaChange',
        component: ItemHiraganaChange,
        meta: {
          pageName: '品目設定'
      },
    },
    {
        path: 'chemical-import-error-list',
        name: 'ChemicalImportErrorList',
        component: ChemicalImportErrorList,
        meta: {
          pageName: '農薬取込みエラー一覧',
        },
      },
    ]
  },
  {
    path: '/user-list',
    name: 'UserList',
    component: UserList,
    meta: {
      pageName: 'ユーザー一覧',
      parent: true
    }
  },
  {
    path: '/pdf-output',
    name: 'PdfOutput',
    component: JasperReports,
    meta: {
      pageName: 'PDF OUTPUT',
      parent: true
    }
  },
  {
    path: '/additional-function',
    name: 'AdditionalFunction',
    component: AdditionalFunction,
    meta: {
      pageName: '便利な機能',
      parent: true
    },
    children: [   
      {
        path: 'shipping-collective-register-list',
        name: 'shippingCollectiveRegisterList',
        component: ShippingCollectiveRegisterList,
        meta: {
          pageName: '出荷記録まとめて登録一覧'
        }
      }, 
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: (() => {
    // パスから取得
    const regstr = new RegExp('/tenants/([^/]+)');
    const regx = location.pathname.match(regstr);
    if (regx && regx.length > 0) {
      return `/tenants/${regx[1]}/`;
    } else {
      return '/'
    }
  })(),
  routes
});

router.afterEach((to, from) => {
  const record = to.matched.find(record => record.meta.parent);
  store.dispatch('doUpdateParentPageName', record?.meta.pageName);
  store.dispatch('doUpdateParentPageNames', record?.meta?.parents);
  if (!to.meta?.parent) {
    store.dispatch('doUpdateCurrentPageName', to.meta?.pageName);
    store.dispatch('doUpdateParentPageNames', to.meta?.parents);
  } else {
    store.dispatch('doUpdateCurrentPageName', '');
  }
});
router.beforeEach((to, from, next) => {
    if (store.getters.isInputChanged && !store.getters.isHiddenSwitched) {
        const confirm = window.confirm(
            "変更内容を破棄します。よろしいですか？"
        );
        if (confirm) {
            store.dispatch("doUpdateIsInputChanged", false);
            next();
        } else {
            next(false)
        }
    } else {
        next();
    }
});

export default router
